module.exports = __webpack_public_path__ + "media/src/images/icon/checked-5ee701048989c2d49990132da9268586.svg";